<template>

  <a-card
    :bordered="false"
    :class="{card: true}"
    >
    <div slot="title" v-if="taskList.title || editing">
      {{ taskList.title }}
    </div>
    <div slot="extra" v-if="taskList.extra || editing">
      {{ taskList.extra }}
    </div>

    <p v-show="editing">
      <a-input
        v-model="title"
        suffix="Title"
        class="edit-title-input"
        :ref="'titleEditingInput'"
        @pressEnter="editing=false;"
        />
      <a-input
        v-model="extra"
        suffix="Extra"
        class="edit-extra-input"
        @pressEnter="editing=false;"
        />
      <a-button
        type="primary"
        class="edit-done-button"
        @click="editing=false;"
        >
        Done
      </a-button>
    </p>

    <draggable
      v-show="!editing"
      v-model="tasks"
      group="tasks"
      filter=".undragabble"
      @start="drag=true"
      @end="drag=false"
    >

    <p v-for="(task, i) in taskList.tasks" :key="task.id">
      <a-icon v-if="!userPreferences['layout.hideDragHandle']" type="ellipsis" class="drag-handle"></a-icon>
      <a-checkbox
        :checked="task.done"
        @change="onTaskCheckboxChange($event, task)"
      />
      <span
        :class="{taskSpan: true, done: task.done}"
        contentEditable="true"
        v-text="task.text"
        :ref="'taskSpans'"
        @keypress="onTaskSpanKeyPress"
        @keydown="onTaskSpanKeyDown($event, task, i)"
        @keyup="onTaskSpanKeyUp($event, task, i)"
        @blur="onTaskSpanBlur($event, task)"
      />
    </p>
    <p slot="footer" class="undragabble">
      <span @click="onPlusClick" class="addTask">
        <a-icon type="plus" /> Add task
      </span>
      <a-dropdown :trigger="['click']">
        <span class="card-settings-button">
          <a-icon type="edit" />
        </span>
        <a-menu slot="overlay">
          <a-menu-item
            key="1"
            @click="startEditing()"
            >
              <a-icon type="font-size" /> Set list title
            </a-menu-item>
          <a-menu-item
            key="2"
            @click="onDeleteClick">
              <a-icon type="delete" /> Delete list
            </a-menu-item>
        </a-menu>
      </a-dropdown>
    </p>

    </draggable>

  </a-card>


</template>


<script>
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import { setEndOfContenteditable, shortId } from '@/utils';


export default {
  name: "TaskList",
  props: ["id","taskList"],
  components: {
    draggable,
  },
  computed: {
    ...mapGetters({
      userPreferences: 'prefs/getUserPreferences',
    }),
    title: {
      get() {
        return this.taskList.title;
      },
      set(value) {
        this.$store.commit(
          'boards/editTaskList',
          {taskList: this.taskList, key: "title", value: value},
        );
        this.$emit("taskListUpdated");
      }
    },
    extra: {
      get() {
        return this.taskList.extra;
      },
      set(value) {
        this.$store.commit(
          'boards/editTaskList',
          {taskList: this.taskList, key: "extra", value: value},
        );
        this.$emit("taskListUpdated");
      }
    },
    tasks: {
      get() {
        return this.taskList.tasks;
      },
      set(value) {
        this.$store.commit(
          'boards/editTaskList',
          {taskList: this.taskList, key: "tasks", value: value},
        );
        this.$emit("taskListUpdated");
      }
    },
  },
  data() {
    return {
      editing: false,
    }
  },
  updated(){
    // console.log("TaskList updated");
    // this.$emit("taskListUpdated");
  },
  methods: {

    addNewTask(position) {
      const newId = shortId();
      const newTask = {id: newId, text: "", done: false};
      this.$store.commit(
        'boards/addTask',
        {taskList: this.taskList, position, task: newTask}
      );
      this.$emit("taskListUpdated");
      this.$nextTick(() => {
        this.$refs.taskSpans[this.taskList.tasks.length - 1].focus()
        }
      );
    },
    removeTask(position) {
      this.$store.commit(
        'boards/removeTask',
        {taskList: this.taskList, position}
      );
      this.focusTask(position - 1);
      this.$emit("taskListUpdated");
    },

    focusTask(position) {
      if (position < 0 || position >= this.taskList.tasks.length) return;
      const compare = (a, b) => a.offsetTop-b.offsetTop;
      const spanAtPosition = this.$refs.taskSpans.sort(compare)[position];
      spanAtPosition.focus();
      setEndOfContenteditable(spanAtPosition);
    },

    startEditing() {
      this.editing = true;
      this.$nextTick(() => {
        this.$refs.titleEditingInput.focus()
      });
    },

    onDeleteClick() {
      this.$emit("deleteTaskList", {"id": this.id})
    },

    onPlusClick() {
      this.addNewTask(this.taskList.tasks.length);
    },

    onTaskCheckboxChange(event, task) {
      this.$store.commit(
        'boards/editTask',
        {task, key: "done", value: event.target.checked}
      );
      this.$emit("taskListUpdated");
    },

    onTaskSpanBlur(event, task) {
      this.$store.commit(
        'boards/editTask',
        {task, key: "text", value: event.target.textContent}
      );
      this.$emit("taskListUpdated");
    },

    onTaskSpanKeyPress(event) {
      if (
        event.key == "Enter" &&
        event.altKey === false &&
        event.ctrlKey === false &&
        event.shiftKey === false
      ) {
        event.preventDefault();
      }
    },

    onTaskSpanKeyDown(event, task, position) {
      //console.log(event);
      switch(event.key){
        case "Backspace":
          if (!event.target.textContent) {
            this.removeTask(position);
            event.preventDefault();
          }
          break;
        case "ArrowUp":
          this.focusTask(position - 1);
          event.preventDefault();
          break;
        case "ArrowDown":
          this.focusTask(position + 1);
          event.preventDefault();
          break;
      }

    },

    onTaskSpanKeyUp(event, task, position) {
      if (
        event.key == "Enter" &&
        event.altKey === false &&
        event.ctrlKey === false &&
        event.shiftKey === false
      ) {
        this.addNewTask(position + 1);
      }
    },

  },
}
</script>


<style scoped>

[contenteditable]:focus {
    outline: 0px solid transparent;
}

p {
  text-align: left;
}

.card-settings-button {
  cursor: pointer;
  float: right;
  opacity: .5;
}

.card-settings-button:hover {
  opacity: .75;
}

.done {
  text-decoration: line-through;
  color: #bbb;
}

.addTask {
  cursor: pointer;
}

.card {
  flex: 1;
  min-width: 250px;
  max-width: 350px;
  margin-left: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.drag-handle {
  float: right;
  cursor: move;
}

.taskSpan {
  white-space: pre-wrap;
}

.edit-title-input, .edit-extra-input {
  margin-bottom: 15px;
}

.edit-done-button {
  float: right;
}

</style>

